// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2AmGM","header":"MergedInvoice_header__313ep"};